import { MenuDataItem, ProLayoutProps } from '@ant-design/pro-layout'
import { Route } from '@ant-design/pro-layout/es/typing'
import { useQuery } from '@apollo/client'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useCallback } from 'react'

import {
  ProductProviderMemberDocument,
  ProductProviderMemberRole,
} from '../../generated/graphql'
import { BlankFooter } from './Footer'
import { PageContainer } from './PageContainer'

const AntdProLayout = dynamic(
  async () => (await import('@ant-design/pro-layout')).ProLayout,
  { ssr: false }
)

type Props = Required<Pick<ProLayoutProps, 'route'>> & {
  children: React.ReactNode
}

export const BasicLayout: React.FC<Props> = ({ route, children }) => {
  const { loading, data } = useQuery(ProductProviderMemberDocument)
  const router = useRouter()
  const handleMenuHeaderClick = useCallback(() => router.push('/'), [router])
  const handleMenuItemRender = useCallback(
    (options: MenuDataItem, element: React.ReactNode) => (
      <Link href={options.path!}>{element}</Link>
    ),
    []
  )

  if (loading || !data) return <PageContainer loading />

  return (
    <AntdProLayout
      title="HH cross TOWNS"
      logo={null}
      route={getRouteForRole(route, data?.productProviderMember.role)}
      navTheme="light"
      layout="side"
      fixSiderbar
      onMenuHeaderClick={handleMenuHeaderClick}
      menuItemRender={handleMenuItemRender}
      footerRender={BlankFooter}
      style={layoutStyle}
    >
      {children}
    </AntdProLayout>
  )
}

const getRouteForRole = (route: Route, role: ProductProviderMemberRole) => {
  // オーナー
  if (role === 'owner') {
    return route
  }

  // レビュワー
  return {
    routes: route.children?.filter(
      (item) => item.path === '/simple_pass/my_passes'
    ),
  }
}
const layoutStyle = { minHeight: '100vh' }
